export default "/img/spike-logo.svg"